import { baseURL, post, get, put } from './config'

export const isRefresh = true
export const uploadURL = baseURL + '/weapi/v1/uploads'

// export const downloadModel = {
//   'production': '',
//   'development': 'http://192.168.1.186:9903/预算科目模版.xlsx',
//   'lan': 'http://192.168.1.124:8060/预算科目模版.xlsx'
// }[process.env.NODE_ENV]

/* 公共接口 start */

/**
 * 上传图片
 * @param {*} data
 */
export const uploads = (data) => post(`/weapi/v1/uploads`, data)

/**
 * 删除图片
 * @param {*} data
 */
export const removeFile = (data) => get(`/weapi/v1/upload/remove`, data)

/* 公共接口 end */

/* 登录 start */

/**
 * 后台登录
 * @param {*} data
 */
export const login = (data) => post(`/weapi/v1/login`, data)

/**
 * 修改密码
 * @param {*} data
 */
export const updatePassword = (data) => put(`/weapi/v2/change`, data)

/**
 * 退出登录
 */
export const signOut = () => get(`/weapi/v1/logout`)

/* 登录 end */

/* 门店管理 start */

/**
 * 获取门店列表
 * @param {*} data
 */
export const getShopsList = (data) => get(`/weapi/v1/shops`, data)

/**
 * 添加门店信息
 * @param {*} data
 */
export const addShop = (data) => post(`/weapi/v1/shop`, data)

/**
 * 获取门店信息
 * @param {*} id
 */
export const getShopDetails = (id) => get(`/weapi/v1/shop/${id}`)

/**
 * 编辑门店信息
 * @param {*} id
 * @param {*} data
 */
export const updateShopDetails = (id, data) => put(`/weapi/v1/shop/${id}`, data)

/**
 * 变更门店状态
 * @param {*} id
 * @param {*} data
 */
export const changeShopStatus = (id, data) => put(`/weapi/v1/shop/${id}/update_status`, data)

/**
 * 获取门店下拉列表
 * 【不传递或者传递空字符串获取可用的门店列表】 【all 获取全部的门店列表】
 * @param {*} data
 */
export const getShopListDown = (data) => get(`/weapi/v1/shops/down`, data)

/**
 * 根据老板id获取其下门店列表
 * @param {*} data
 */
export const getBossShopListDown = (data) => get(`/weapi/v2/shops/down`, data)

/* 门店管理 end */

/* 品牌管理 start */

/**
 * 获取品牌列表
 * @param {*} data
 */
export const getBrandList = (data) => get(`/weapi/v1/brands`, data)

/**
 * 获取品牌下拉列表
 */
export const getBrandListDown = () => get(`/weapi/v1/brands/down`)

/**
 * 添加品牌信息
 * @param {*} data
 */
export const addBrands = (data) => post(`/weapi/v1/brand`, data)

/**
 * 编辑品牌信息
 * @param {*} id
 * @param {*} data
 */
export const updateBrands = (id, data) => put(`/weapi/v1/brand/${id}`, data)

/**
 * 更新品牌状态
 * @param {*} id
 * @param {*} data
 */
export const changeBrandsStatus = (id, data) => put(`/weapi/v1/brand/${id}/update_status`, data)

/* 品牌管理 end */

/* 店员管理 start */

/**
 * 获取店员列表
 * @param {*} data
 */
export const getClerkList = (data) => get(`/weapi/v1/clerks`, data)

/**
 * 获取店员详情
 * @param {*} data
 */
export const getClerkDetails = (id) => get(`/weapi/v1/clerk/${id}`)

/**
 * 添加店员信息
 * @param {*} data
 */
export const addClerkDetails = (data) => post(`/weapi/v1/clerk`, data)

/**
 * 编辑店员信息
 * @param {*} id
 * @param {*} data
 */
export const updateClerkDetails = (id, data) => put(`/weapi/v1/clerk/${id}`, data)

/**
 * 更新店员状态
 * @param {*} id
 * @param {*} data
 */
export const changeClerkStatus = (id, data) => put(`/weapi/v1/clerk/${id}/update_status`, data)

/* 店员管理 end */

/* 商品管理 start */

/**
 * 添加商品信息
 * @param {*} data
 */
export const addProduct = (data) => post(`/weapi/v1/product`, data)

/**
 * 获取商品详情
 * @param {*} data
 */
export const getProduceDetails = (id) => get(`/weapi/v1/product/${id}`)

/**
 * 获取商品列表
 * @param {*} data
 */
export const getProductList = (data) => get(`/weapi/v1/products`, data)

/**
 * 获取商品下拉
 * @param {*} data
 */
export const getProductListDown = (data) => get(`/weapi/v1/products/down`, data)

/**
 * 变更商品状态
 * @param {*} id
 * @param {*} data
 */
export const changeProductStatus = (id, data) => put(`/weapi/v1/product/${id}/update_status`, data)

/**
 * 创建导出出商品二维码异步任务
 * @param {*} data
 */
export const createDownloadTask = (data) => post(`/weapi/v1/products/export/task`, data)

/**
 * 获取异步任务的状态
 * @param {*} data
 */
export const getTaskStatus = (data) => get(`/weapi/v1/products/export/status`, data)

/* 商品管理 end */

/* 优惠券管理 start */

/**
 * 获取优惠券列表 【 未冻结的优惠券优先】 【同一状态的按照创建时间降序 DESC 】
 * @param {*} data
 */
export const getCoupons = (data) => get(`/weapi/v1/coupons`, data)

/**
 * 获取退款审核列表
 * @param {*} data
 */
export const getRefundList = (data) => get(`/weapi/v1/coupons/refund`, data)

/**
 * 获取优惠券详情
 * @param {*} id
 */
export const getCouponsDetails = (id) => get(`/weapi/v1/coupon/${id}`)

/**
 * 获取优惠券明细
 * @param {*} data
 */
export const getCouponsItems = (id, data) => get(`/weapi/v1/coupon/${id}/detail`, data)

/**
 * 添加新的优惠券
 * @param {*} data
 */
export const addCoupons = (data) => post(`/weapi/v1/coupon`, data)

/**
 * 创建导出优惠券任务
 */
export const createCouponsExportTask = () => post(`/weapi/v1/coupon/export/task`)

/**
 * 获取优惠券导出任务的状态
 * @param {*} data
 */
export const getCouponsExportTaskStatus = (data) => get(`/weapi/v1/coupon/export/status`, data)

/**
 * 冻结优惠券
 * @param {*} id
 */
export const changeCouponsStatus = (id) => put(`/weapi/v1/coupon/${id}/update_status`)

/**
 * 员工 通过审核
 * @param {*} id
 */
export const confirmAudiqueren = (id) => put(`/weapi/v1/coupon/${id}/apply`)

/**
 * 老板 确认退款
 * @param {*} id
 */
export const confirmRefund = (id) => put(`/weapi/v1/coupon/${id}/confirm`)

/* 优惠券管理 end */

/* banner管理 start */

/**
 * 更改首页banner图
 * @param {*} data
 */
export const updateBanners = (data) => post(`/weapi/v1/banners`, data)

/**
 * 获取首页banner图
 * @param {*} data
 */
export const getBanners = (data) => get(`/weapi/v1/banners`, data)

/* banner管理 end */

/* 摄像头管理 start */

/**
 * 获取摄像头列表
 * @param {*} data
 */
export const getCameras = (data) => get(`/weapi/v1/cameras`, data)

/**
 * 添加摄像头
 * @param {*} data
 */
export const addCameras = (data) => post(`/weapi/v1/camera`, data)

/**
 * 获取摄像头详情
 * @param {*} id
 */
export const getCamerasDetails = (id) => get(`/weapi/v1/camera/${id}`)

/**
 * 编辑摄像头信息
 * @param {*} id
 * @param {*} data
 */
export const updateCameras = (id, data) => put(`/weapi/v1/camera/${id}`, data)

/**
 * 改变摄像头状态
 * @param {*} id
 * @param {*} data
 */
export const changeCamerasStatus = (id, data) => put(`/weapi/v1/camera/${id}/status`, data)

/* 摄像头管理 end */

/* 数据管理 start */

/**
 * 获取后台数据统计
 * @param {*} data
 */
// export const getStatistics = (data) => get(`/weapi/v1/statistics`, data)

export const getStatistics = (data) => get(`/weapi/v2/statistics`, data)

/**
 * 创建数据统计导出任务
 * @param {*} data
 */
export const createStatisticsExportTask = (data) => post(`/weapi/v1/statistics/export/task`, data)

/**
 * 查询数据统计导出任务的状态
 * @param {*} data
 */
export const getStatisticsExportTaskStatus = (data) => get(`/weapi/v1/statistics/export/status`, data)

/* 数据管理 end */

/* 账号管理 start */

/**
 * 获取账号列表
 * @param {*} data
 */
export const getAccountList = (data) => get(`/weapi/v2/accounts`, data)

/**
 * 获取老板账号下拉列表
 */
export const getBossAccountList = () => get(`/weapi/v2/accounts/down`)

/**
 * 添加老板账号
 * @param {*} data
 */
export const addBoosAccount = (data) => post(`/weapi/v2/account`, data)

/**
 * 更改账号状态
 * @param {*} data
 */
export const changeAccountStatus = (id, data) => put(`/weapi/v2/account/${id}/status`, data)

/* 账号管理 end */

/* 客户查询 start */

/**
 * 获取客户信息列表
 * @param {*} data
 */
export const getUserList = (data) => get(`/weapi/v2/members`, data)

/**
 * 获取用户门店历史
 * @param {*} data
 */
export const getUserHistory = (id, data) => get(`/weapi/v2/member/${id}/history`, data)

/* 客户查询 end */

/* 门店浏览记录 start */

/**
 * 获取门店浏览记录
 * @param {*} data
 */
export const getShopHistory = (data) => get(`/weapi/v2/shops/history`, data)

/* 门店浏览记录 end */



// WEBPACK FOOTER //
// ./src/api/index.js